<template>
  <div id="app">
    <v-app footer>
      <Header v-if="showBoiler"/>
      <v-content>
        <router-view/>
      </v-content>
      <Footer v-if="showBoiler"/>
    </v-app>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      showBoiler: false,
      suppressPricing: false
    }
  },
  mounted: function () {
    if (this.$route.name === 'manipulative-view') {
      this.showBoiler = false
    } else {
      this.showBoiler = true
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'manipulative-view') {
        this.showBoiler = false
      } else {
        this.showBoiler = true
      }
    }
  },
  computed: {
    isClassroom: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.type === 'classroom';
      }
      return false;
    },
  }
}
</script>

<style>

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
  background-color: white;
}

.display-1, .display-2, .display-3, .display-4, .headline {
  font-family: "Poppins", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.desktop-h1 {
  font-family: "Poppins", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 48px;
  font-weight: bold;
}


.toolbar_text_btn {
  font-family: "Poppins", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.title {
  font-family: "Poppins", sans-serif !important; 
}

.body-3 {
  font-family: "Poppins", sans-serif !important;
  font-weight: 300;
}

.body-5 {
  font-family: "Poppins", sans-serif !important;
  font-weight: 300;
  font-size: 18px;
  color: #607486;
}

a:visited {
    color: #3296f3;
    text-decoration: none;
}
a:link {
    color: #3296f3;
    text-decoration: none;
}
a {
    color: #3296f3;
    text-decoration: none;
}

p {
  margin: 0;
}

.btn_override {
  text-transform: none;
  font-weight: 400;
}

.v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot  {
    border: 4px solid #D7EBFF !important;
    border-radius: 40px !important;
    box-shadow: unset !important;
}
.v-btn {
  text-transform: unset;
  border-radius:20px
}
.theme--light.v-text-field>.v-input__control>.v-input__slot:before {
  opacity: 0;
}
</style>
